import useFetchAdditionalTasks from '../../../hooks/clickup/useFetchAdditionalTasks';
import { clickupReports } from '../../../utils/clickup/config/clickupFieldMap';
import { mapClickUpFields } from '../../../utils/clickup/mapClickUpFields';
import DynamicTable from '../../../components/tables/dynamicTable';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import { useLocation } from 'react-router-dom';
import  { useEffect } from 'react';
import Cookies from 'js-cookie';

const CUReport = () => {
  const companyName = Cookies.get('cp-cn')
  const location = useLocation();
  const { reportName, reportId } = location.state || {};

  let clickup_vals = clickupReports[reportName]

  const hasCachedData = Boolean(sessionStorage.getItem(reportName));
  const cachedRows = hasCachedData ? JSON.parse(sessionStorage.getItem(reportName)) : null;

  const { tasks: listData } = useFetchAdditionalTasks(clickup_vals.listId, null, hasCachedData);
  const reportRows = (Array.isArray(listData) && listData.length > 0)
    ? mapClickUpFields(listData, clickup_vals.fields)
    : cachedRows || [];

  // TODO: Fix this in the backend to filter so can't change and see data
  const rows = reportRows.filter(row => row.client_name === companyName) || [];

  useEffect(() => {
    if (rows && rows.length > 0) {
      sessionStorage.setItem(reportName, JSON.stringify(rows));
    }
  }, [listData, rows]);

  return (
    <div className="page">
      <div className="LandingPageContainer">
        <NavBar />
        <Sidebar />
          <div className="tableReportsPageContent">
          <div className="scoreBoardTitle">
            <h1>{reportName}</h1>
          </div>
          <div className="tableReportsSpace">
            <div className="report">
              <DynamicTable dataObject={{data: rows}} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CUReport;